import LoggerService,{formatTrace,formatInfo} from '../../LoggerService';
import {_checkErrors} from './_base';

import I_SAML_2, {I_SAML_1} from '../interfaces/I_SAML';
import I_LOGIN from '../interfaces/I_LOGIN';
import {
  getMicrosoftLinkResponse,
  getMicrosoftTokensResponse,
} from '../ApiEndpoints';

// ---------------------------------
// --- LOGIN MICROSOFT
// ---------------------------------

const logger = LoggerService.getInstance();


/**
 * Récupère l'URL de connexion Microsoft (step 1)
 * @param obj
 * @returns
 */
const getLink = async ():Promise<I_SAML_1> => {
  logger.debug('ApiServices - getMicrosoftLinkResponse - ');
  // requete le endpoint
  const response = await getMicrosoftLinkResponse();
  logger.trace(...formatTrace('ApiServices - getMicrosoftLinkResponse - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_SAML_1 = await response.json();
  logger.debug('ApiServices - getMicrosoftLinkResponse - ok, returned body',body);
  return body;
};

/**
 * Envoie les infos de connexion Microsoft au back, récupère les token (step 3)
 * @param obj
 * @returns
 */
const connect = async ({
  code,
  session_state,
  state,
  client_info,
  redirect_uri,
}:{
  code:string,
  session_state:string,
  state:string,
  client_info:string,
  redirect_uri:string,
}):Promise<I_LOGIN> => {
  logger.debug('ApiServices - connectMicrosoftResponse - ');
  // requete le endpoint
  const response = await getMicrosoftTokensResponse({
    code,
    session_state,
    state,
    client_info,
    redirect_uri,
  });
  logger.trace(...formatTrace('ApiServices - connectMicrosoftResponse - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_SAML_2 = await response.json();
  logger.debug('ApiServices - connectMicrosoftResponse - ok, returned body',body);
  return body?.token;
};

const microsoftServices = {
  getLink,
  connect,
};

export default microsoftServices;
